import "antd/dist/reset.css";
import { Collapse,Empty, message } from "antd";
import React from "react";
import utils from "utils";
import api from '../../utils/api';
import "./SOSSummaryChild.scss";
import Loader from "Components/Loader";
const { Panel } = Collapse;


class GeriatricSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           result : [],
           isLoading: false,
        }
    }
    componentDidMount()
    {   
      let data={
        patient_id: this.props.data?.patient_id,
        type: this.props.data?.user_type,  
      }
      if(this.props.title=="CONFAS")  
        { this.setState({ isLoading: true });
          api.get_confas_summary_list(data).then((res)=>{
            if (res.data?.status == 200) { 
              this.setState({result:res.data, isLoading: false,})
            }else{
              message.error(res.data?.message, ErrorDuration);
              this.setState({isLoading: false})
            }
          })}

            if(this.props.title=="CONPSYQ")
            { this.setState({ isLoading: true });
              api.get_conpsyg_summary_list(data).then((res)=>{
              if (res.data?.status == 200) { 
                this.setState({result:res.data, isLoading: false,})
              }else{
                message.error(res.data?.message, ErrorDuration);
                this.setState({isLoading: false})
              }
            })}
    }
   
    render()
    {
        return (
    
            <>
            {this.state.isLoading ? (
              <Loader />
            ) : (
             <div className="mhe-wrapper-container">
                    <div className="mhe-header">
                      <div>{this.props.title}</div>
                    </div>
        
                    <div className="mhe-content">
                      {this.state?.result?.data?.count == 0 ? (
                        <Empty
                          description={"No Data"}
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                      ) : (              
                         <Collapse
                        style={{ overflowY: "auto" }}
                        bordered={false}
                        expandIconPosition="start"
                        ghost={true}
                        className="mhe-list-container"
                        >
                            {this.state?.result?.data?.results.map((data,i)=>{
                                return(
                                    <Panel key={i}
                                    header={
                                    <div>
                                        {utils.FormatDate(data.completion_date, "DATE_14")},{" "}
                                        {utils.FormatDate(data.completion_date, "TIME_1")}{"  "}<span style={{color:"#107569", fontWeight:"700"}}>{`(Score: ${data.values?.scores?.total_score||"0"}/${data.values.scores.overall_score})`}</span>
                                    </div>
                                    }
                                    extra={utils.FirstNameLastName(utils.salutationPrefixName(data.doctor_salutation,utils.getDisplayName(data.consultation_doctor, data.doctor_last_name)), "250px")}
                                >
                                   
                                    <div>{utils.RecursiveSummary(data.values)}</div>                  
                                </Panel>
                                )
                            })}
                           

                        </Collapse>
                       
                      )}
                    </div>
                  </div>
            )}
            </>
          )
    }
 
};

export default GeriatricSummary;
